var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18443 2.36816L1.35285 10.7223C1.31345 10.7645 1.285 10.8177 1.27145 10.8749L0.403394 14.5913C0.377428 14.7032 0.408248 14.8221 0.484792 14.9038C0.542707 14.9655 0.621621 14.9997 0.702342 14.9997C0.727066 14.9997 0.752355 14.9965 0.776966 14.9899L4.26116 14.0638C4.31546 14.0494 4.3648 14.0192 4.4042 13.9771L12.2365 5.6236L9.18443 2.36816Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1379 1.36033L13.2345 0.45406C12.6308 -0.151647 11.5785 -0.15106 10.9754 0.45406L9.8688 1.56419L13.0313 4.73684L14.1379 3.62671C14.4395 3.32427 14.6056 2.92172 14.6056 2.49358C14.6056 2.06544 14.4395 1.66289 14.1379 1.36033Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.0919d2e37a1b68966f11e5476d793b5f.svg";
export { ForwardRef as ReactComponent };